import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LegalFooter } from "@/components/LegalFooter";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum – Xenomons" },
      {
        name: "description",
        content:
          "Impressum und Anbieterkennzeichnung der Schmetti GmbH, Betreiberin von Xenomons.",
      },
      { property: "og:title", content: "Impressum – Xenomons" },
      {
        property: "og:description",
        content: "Anbieterkennzeichnung der Schmetti GmbH, Betreiberin von Xenomons.",
      },
      { property: "og:url", content: "https://xenomons.online/impressum" },
    ],
    links: [
      { rel: "canonical", href: "https://xenomons.online/impressum" },
      { rel: "alternate", hrefLang: "de", href: "https://xenomons.online/impressum" },
      { rel: "alternate", hrefLang: "en", href: "https://xenomons.online/impressum" },
      { rel: "alternate", hrefLang: "x-default", href: "https://xenomons.online/impressum" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "Schmetti GmbH",
          url: "https://xenomons.online/",
          email: "webmaster@xenomons.online",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Budapester Str. 44",
            postalCode: "20359",
            addressLocality: "Hamburg",
            addressCountry: "DE",
          },
        }),
      },
    ],
  }),
  component: Impressum,
});

function Impressum() {
  const { t } = useTranslation("legal");
  return (
    <main className="min-h-screen flex flex-col bg-background">
      <div className="flex-1 px-6 py-10">
        <div className="mx-auto max-w-2xl">
          <Link to="/" className="text-sm font-medium text-primary hover:underline">
            {t("back")}
          </Link>
          <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight">
            {t("imprint.title")}
          </h1>

          <section className="mt-6 space-y-4 text-sm leading-relaxed">
            <p className="font-bold uppercase tracking-widest text-muted-foreground text-xs">
              {t("imprint.tmg")}
            </p>

            <address className="not-italic">
              <strong>{t("imprint.company")}</strong>
              <br />
              {t("imprint.address_line1")}
              <br />
              {t("imprint.address_line2")}
            </address>

            <p>
              <strong>{t("imprint.ceo_label")}</strong>
              <br />
              {t("imprint.ceo_1")}
              <br />
              {t("imprint.ceo_2")}
            </p>

            <p>
              <strong>{t("imprint.contact_label")}</strong>
              <br />
              {t("imprint.email_label")}{" "}
              <a className="underline" href="mailto:webmaster@xenomons.online">
                webmaster@xenomons.online
              </a>
            </p>

            <p>
              <strong>{t("imprint.register_label")}</strong>
              <br />
              {t("imprint.register_value")}
            </p>

            <p>
              <strong>{t("imprint.tax_label")}</strong> {t("imprint.tax_value")}
              <br />
              <strong>{t("imprint.vat_label")}</strong> {t("imprint.vat_value")}
            </p>

            <p>
              <strong>{t("imprint.mstv_label")}</strong>
              <br />
              {t("imprint.mstv_value")}
            </p>

            <h2 className="pt-4 text-lg font-bold">{t("imprint.liability_content_title")}</h2>
            <p>{t("imprint.liability_content")}</p>

            <h2 className="pt-4 text-lg font-bold">{t("imprint.liability_links_title")}</h2>
            <p>{t("imprint.liability_links")}</p>

            <h2 className="pt-4 text-lg font-bold">{t("imprint.copyright_title")}</h2>
            <p>{t("imprint.copyright")}</p>
          </section>
        </div>
      </div>
      <LegalFooter />
    </main>
  );
}
